var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "vs-root" },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.$ct("default-edit-tabs.title", { name: _vm.browseName }))
        ),
      ]),
      _c(
        "w-card-content",
        { staticClass: "vs-content" },
        [
          _c("div", { staticClass: "vs-sub" }, [
            _vm._v(_vm._s(_vm.$ct("default-edit-tabs.description"))),
          ]),
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "div",
              { key: tab.key, staticClass: "vs-row" },
              [
                _c(
                  "span",
                  {
                    staticClass: "vs-name",
                    class: { muted: _vm.isHidden(tab.key) },
                  },
                  [_vm._v(_vm._s(tab.label()))]
                ),
                tab.required
                  ? _c("span", { staticClass: "vs-meta" }, [
                      _vm._v(
                        _vm._s(_vm.$ct("default-edit-tabs.always-visible"))
                      ),
                    ])
                  : _c("w-switch", {
                      staticClass: "vs-switch",
                      attrs: { value: !_vm.isHidden(tab.key) },
                      on: {
                        input: function ($event) {
                          return _vm.setVisible(tab.key, $event)
                        },
                      },
                    }),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm.isOwner
        ? _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "users", disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      return _vm.applyToAllUsers()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$ct("default-edit-tabs.apply-to-all-users")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }